// eslint-disable-next-line import/no-named-as-default
import { api } from './base.service';

// http://localhost:7025/engine/schedule/yearly/ATCU1/

export const getAllAnnualPlans = (atcu) => {
    return api().get(`/api/schedules/yearly/${atcu}`);
};

// localhost:7025/engine/yearly-plans/ATCU1/2024
export const removeAnnualPlan = (atcu, year) => {
    return api().delete(`/api/yearly-plans/year/${year}/atcu/${atcu}`);
}

// /engine/sector-opening-schemes/set-approve-status/{id}
// localhost:7025/engine/sector-opening-schemes/set-approve-status/68?approveStatus=DISCARD
export const setApproveStatus = (id, status) => {
    return api().patch(`/api/sector-opening-schemes/set-approve-status/${id}?approveStatus=${status}`);
}
